import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade umt-form",
  id: "kt_modal_scholarship_approve",
  ref: "modalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header p-3" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center flex-wrap gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Duyệt học bổng", -1)
const _hoisted_7 = {
  key: 0,
  class: "ms-2"
}
const _hoisted_8 = {
  key: 1,
  class: "fs-6 fw-semibold text-gray-500"
}
const _hoisted_9 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body pt-5 pb-4" }
const _hoisted_14 = { class: "d-flex flex-stack mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-gray-800 border-start border-4 border-primary ps-3 m-0" }, "Thông tin đăng ký", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right me-1" }, null, -1)
const _hoisted_17 = { class: "row g-4" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-8 mb-1" }, "Học bổng ĐK", -1)
const _hoisted_20 = { class: "fw-semibold text-gray-800" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-8 mb-1" }, "Ngành ĐK", -1)
const _hoisted_23 = { class: "fw-semibold text-gray-800" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-8 mb-1" }, "Ngày sinh", -1)
const _hoisted_26 = { class: "fw-semibold text-gray-800" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-8 mb-1" }, "SĐT", -1)
const _hoisted_29 = { class: "fw-semibold text-gray-800" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-8 mb-1" }, "Trường THPT", -1)
const _hoisted_32 = { class: "fw-semibold text-gray-800" }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-8 mb-1" }, "Tỉnh/TP L12", -1)
const _hoisted_35 = { class: "fw-semibold text-gray-800" }
const _hoisted_36 = { class: "card-body border-top pt-5 pb-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-gray-800 border-start border-4 border-primary ps-3 mb-4" }, "Quyết định cấp học bổng", -1)
const _hoisted_38 = { class: "border border-primary border-dashed rounded bg-light-primary p-4" }
const _hoisted_39 = { class: "row g-4" }
const _hoisted_40 = { class: "col-md-6 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Quyết định", -1)
const _hoisted_42 = {
  key: 0,
  class: "col-md-6 fv-row"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Số thông báo", -1)
const _hoisted_44 = {
  key: 1,
  class: "col-md-6 fv-row"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Ngày thông báo", -1)
const _hoisted_46 = {
  key: 2,
  class: "col-md-6 fv-row"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Đợt xét học bổng", -1)
const _hoisted_48 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Lý do từ chối", -1)
const _hoisted_50 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_51 = { class: "border border-primary border-dashed rounded bg-light-primary p-4" }
const _hoisted_52 = { class: "col-md-6 fv-row" }
const _hoisted_53 = { class: "col-md-6 fv-row" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "form-label text-gray-500" }, "Học phí toàn khóa", -1)
const _hoisted_56 = {
  key: 0,
  class: "text-danger fs-8 mt-1"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle me-1" }, null, -1)
const _hoisted_58 = {
  key: 1,
  class: "text-muted fs-8 mt-1 fst-italic"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "form-label text-gray-500" }, "Tỷ lệ giảm", -1)
const _hoisted_62 = { class: "fw-bolder text-gray-800 pt-2 text-nowrap" }
const _hoisted_63 = {
  key: 0,
  class: "col-md-4 text-end"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "form-label opacity-0 d-block" }, "x", -1)
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }),
  /*#__PURE__*/_createTextVNode("Mỗi ứng viên chỉ được nhận 1 học bổng cho mỗi hồ sơ. Học phí toàn khóa và tỷ lệ giảm tự tính theo học bổng đã chọn.")
], -1)
const _hoisted_69 = { class: "card-footer d-flex align-items-center justify-content-end gap-3 py-4" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", {
  "data-bs-dismiss": "modal",
  class: "btn btn-light umt-btn-32"
}, "Hủy", -1)
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["title"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-circle me-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, [
            _hoisted_6,
            (_ctx.isMultiApproved)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.multiCount) + ")", 1))
              : _createCommentVNode("", true),
            (!_ctx.isMultiApproved && _ctx.dataCustomer.fullName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "— " + _toDisplayString(_ctx.dataCustomer.fullName) + " · " + _toDisplayString(_ctx.dataCustomer.admissionRegisterCode), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              rules: _ctx.rules,
              model: _ctx.dataCustomer,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      (_ctx.dataCustomer.studentId && _ctx.dataCustomer.canViewStudent !== false)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/danhsachungvien/${_ctx.dataCustomer.studentId}`,
                            target: "_blank",
                            class: "btn btn-sm btn-light-primary py-1 px-3"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _createTextVNode("Xem hồ sơ đầy đủ ")
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.dataCustomer.regScholarshipName ? `${_ctx.dataCustomer.regScholarshipName}${_ctx.dataCustomer.regScholarshipCode ? ` (${_ctx.dataCustomer.regScholarshipCode})` : ''}` : '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.dataCustomer.majorName || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.dataCustomer.dateOfBirth || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.dataCustomer.phone || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.dataCustomer.schoolName || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.dataCustomer.schoolProvince || '—'), 1)
                      ])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_component_el_select, {
                            class: "el-select form-select-solid w-100",
                            "popper-class": "umt-form-dd",
                            modelValue: _ctx.dataCustomer.status,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataCustomer.status) = $event)),
                            onChange: _ctx.handleChangeStatus,
                            placeholder: "Trạng thái"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Duyệt",
                                value: "approved"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Duyệt")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, {
                                label: "Từ chối",
                                value: "rejected"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Từ chối")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        (_ctx.dataCustomer.status == 'approved')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _hoisted_43,
                              _createVNode(_component_el_form_item, { prop: "issuedNo" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.dataCustomer.issuedNo,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataCustomer.issuedNo) = $event)),
                                    placeholder: "Số thông báo"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.dataCustomer.status == 'approved')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode(_component_el_form_item, { prop: "issuedDate" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    class: "el-date-picker w-100",
                                    modelValue: _ctx.dataCustomer.issuedDate,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataCustomer.issuedDate) = $event)),
                                    type: "date",
                                    placeholder: "Ngày/tháng/năm",
                                    format: "DD/MM/YYYY"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.dataCustomer.status == 'approved')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _hoisted_47,
                              _createVNode(_component_el_form_item, { prop: "issuedPhase" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.dataCustomer.issuedPhase,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataCustomer.issuedPhase) = $event)),
                                    placeholder: "Đợt"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.dataCustomer.status == 'rejected')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _hoisted_49,
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              rows: 3,
                              modelValue: _ctx.dataCustomer.rejectReason,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataCustomer.rejectReason) = $event)),
                              placeholder: "Nhập lý do từ chối..."
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])), [
                    [_directive_permission, [_ctx.Permission.SCHOLARSHIP_APPROVE, _ctx.Permission.SCHOLARSHIP]]
                  ]),
                  (_ctx.dataCustomer.status == 'approved')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrScholarshipA, (row, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(["row g-4 align-items-start mb-1", { 'border-top border-gray-200 border-dashed pt-3 mt-1': index > 0 }])
                            }, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("label", {
                                  class: _normalizeClass([{'required': index == 0}, "form-label"])
                                }, "Học bổng cấp", 2),
                                (index == 0)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      prop: "issuedScholarshipId"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          class: "el-select form-select-solid w-100",
                                          "popper-class": "umt-form-dd",
                                          onChange: ($event: any) => (_ctx.selectChangeScholarShip($event,index)),
                                          filterable: "",
                                          modelValue: row.issuedScholarshipId,
                                          "onUpdate:modelValue": ($event: any) => ((row.issuedScholarshipId) = $event),
                                          placeholder: "Chọn học bổng cấp"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipOptions, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: `${item.name} (${item.code})`,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      class: "el-select form-select-solid w-100",
                                      "popper-class": "umt-form-dd",
                                      onChange: ($event: any) => (_ctx.selectChangeScholarShip($event,index)),
                                      filterable: "",
                                      modelValue: row.issuedScholarshipId,
                                      "onUpdate:modelValue": ($event: any) => ((row.issuedScholarshipId) = $event),
                                      placeholder: "Chọn học bổng cấp"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: `${item.name} (${item.code})`,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"]))
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("label", {
                                  class: _normalizeClass([{'required': index == 0}, "form-label"])
                                }, "Ngành nhận học bổng", 2),
                                (index == 0)
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 0,
                                      prop: "issuedMajorId"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          class: "el-select form-select-solid w-100",
                                          "popper-class": "umt-form-dd",
                                          modelValue: row.issuedMajorId,
                                          "onUpdate:modelValue": ($event: any) => ((row.issuedMajorId) = $event),
                                          onChange: ($event: any) => (_ctx.selectChangeMajor($event,index)),
                                          placeholder: "Chọn ngành nhận"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.majorOptions?.filter(i => i.programtype == row.programtype && _ctx.admissionMajorOptions.some(a => a.majorCode == i.majorCode))||[], (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.majorCode+' - '+item.name,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      class: "el-select form-select-solid w-100",
                                      "popper-class": "umt-form-dd",
                                      modelValue: row.issuedMajorId,
                                      "onUpdate:modelValue": ($event: any) => ((row.issuedMajorId) = $event),
                                      onChange: ($event: any) => (_ctx.selectChangeMajor($event,index)),
                                      placeholder: "Chọn ngành nhận"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.majorOptions?.filter(i => i.programtype == row.programtype && _ctx.admissionMajorOptions.some(a => a.majorCode == i.majorCode))||[], (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.majorCode+' - '+item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", {
                                  class: _normalizeClass(["fw-bolder pt-2", _ctx.hasFee(row) ? 'text-gray-800' : 'text-danger'])
                                }, _toDisplayString(row.wholeCourseFee || '—'), 3),
                                (row.issuedMajorId && !_ctx.hasFee(row))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _hoisted_57,
                                      _createTextVNode("Ngành này chưa cài học phí — "),
                                      _createVNode(_component_router_link, {
                                        to: "/caidatthutucnhaphoc/hocphi",
                                        target: "_blank",
                                        class: "text-danger text-decoration-underline"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mở cài đặt học phí")
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (row.feeChangedNote)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                        _hoisted_59,
                                        _createTextVNode(_toDisplayString(row.feeChangedNote), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("div", _hoisted_62, _toDisplayString((row.rateShow != null && row.rateShow !== '') ? (isNaN(+row.rateShow) ? row.rateShow : Math.round(+row.rateShow * 100) + '%') : '—'), 1)
                              ]),
                              (index > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("span", {
                                      class: "btn btn-sm btn-icon btn-light-danger",
                                      title: "Gỡ dòng học bổng thừa (bản ghi cũ)",
                                      onClick: ($event: any) => (_ctx.removeRowScholar(index))
                                    }, _hoisted_67, 8, _hoisted_65)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ]),
                        _hoisted_68
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    (_ctx.dataCustomer.status == 'approved')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          disabled: _ctx.saving,
                          class: "btn btn-light-primary umt-btn-32",
                          title: "Lưu thông tin quyết định — CHƯA cấp học bổng"
                        }, "Lưu", 8, _hoisted_71))
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createElementBlock("span", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.approvedFunction && _ctx.approvedFunction(...args))),
                      class: _normalizeClass(["btn btn-primary cursor-pointer umt-btn-32", { 'disabled': _ctx.saving }]),
                      title: _ctx.dataCustomer.status == 'rejected' ? 'Xác nhận TỪ CHỐI cấp học bổng' : 'Xác nhận CẤP học bổng theo quyết định'
                    }, [
                      _hoisted_73,
                      _createTextVNode("Xác nhận ")
                    ], 10, _hoisted_72)), [
                      [_directive_permission, [_ctx.Permission.SCHOLARSHIP_APPROVE, _ctx.Permission.SCHOLARSHIP]]
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["rules", "model"])
          ])
        ])
      ])
    ])
  ], 512))
}